import { Heading,} from "../../components";
import Navbar from "components/Navbar";
import React, { useEffect, useState } from 'react';
import axios from 'axios';

//const apiUrl = process.env.REACT_APP_API_URL;
const apiUrl = "https://engine.tailriskglobal.com/api/set_sso_cookie";

export default function PBIReport() {
  const [loading, setLoading] = useState(false);
  const [iframeVisible, setIframeVisible] = useState(false);
  const [reportUrl, setReportUrl] = useState("");
  //const [token, setToken] = useState(null);

  const handleSSOLogin = async () => {
      setLoading(true);
      const token = sessionStorage.getItem('token');
      //setToken(token)

      try {
        // ⛳ Replace with actual backend URL in production
        const res = await axios.post(apiUrl, {}, 
          {
            params: {
                token
            },
            headers: {
              'accept': 'application/json',
              'Content-Type': 'application/json',
            },
            withCredentials: true, // 🔐 Important: allow cookies to be set
          });

        console.log('API Response:', res.data)

        // ✅ SSO succeeded, show embedded report
        setReportUrl(
          "https://dashboard.tailriskglobal.com/en/embed?workspaceId=3566&reportId=14801&portalId=1200&type=report"

        );
        setIframeVisible(true);
      } catch (e) {
        console.error("SSO request failed", e);
        alert("Network error, please try again later");
      } finally {
        setLoading(false);
      }
    };

  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h1>One-Click Report Viewer (Embedded)</h1>
      {!iframeVisible && (
        <button onClick={handleSSOLogin} disabled={loading}>
          {loading ? "Logging in..." : "🔐 Login and Load Report"}
        </button>
      )}

      {iframeVisible && (
        <div style={{ marginTop: "20px", height: "85vh" }}>
          <iframe
            src={reportUrl}
            title="Embedded Report"
            width="100%"
            height="100%"
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </div>
      )}
    </div>
  );
}
